{
  "0": {
    "name": "Agathe",
    "age": 24,
    "joy_child": 5,
    "anger_child": 5,
    "love_child": 4,
    "fear_child": 1,
    "excitement_child": 4,
    "loneliness_child": 1,
    "shame_child": 2,
    "satisfaction_child": 3,
    "sadness_child": 2,
    "frustration_child": 5,
    "pleasure_child": 5,
    "jealousy_child": 4,
    "anxiety_child": 2,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 3,
    "relief_child": 2,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 5,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 3,
    "pleasure_teen": 2,
    "jealousy_teen": 3,
    "anxiety_teen": 4,
    "inspiration_teen": 2,
    "regret_teen": 4,
    "boredom_teen": 1,
    "relief_teen": 1,
    "joy_ya": 2,
    "anger_ya": 3,
    "love_ya": 3,
    "fear_ya": 4,
    "excitement_ya": 2,
    "loneliness_ya": 4,
    "shame_ya": 5,
    "satisfaction_ya": 1,
    "sadness_ya": 5,
    "frustration_ya": 5,
    "pleasure_ya": 2,
    "jealousy_ya": 3,
    "anxiety_ya": 5,
    "inspiration_ya": 1,
    "regret_ya": 4,
    "boredom_ya": 1,
    "relief_ya": 2,
    "joy_adult": 5,
    "anger_adult": 2,
    "love_adult": 5,
    "fear_adult": 3,
    "excitement_adult": 5,
    "loneliness_adult": 4,
    "shame_adult": 2,
    "satisfaction_adult": 4,
    "sadness_adult": 3,
    "frustration_adult": 2,
    "pleasure_adult": 5,
    "jealousy_adult": 2,
    "anxiety_adult": 5,
    "inspiration_adult": 4,
    "regret_adult": 2,
    "boredom_adult": 2,
    "relief_adult": 1
  },
  "1": {
    "name": "Victor C",
    "age": 22,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 4,
    "excitement_child": 3,
    "loneliness_child": 1,
    "shame_child": 4,
    "satisfaction_child": 1,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 3,
    "jealousy_child": 3,
    "anxiety_child": 1,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 3,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 2,
    "excitement_teen": 3,
    "loneliness_teen": 1,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 2,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 3,
    "anxiety_teen": 2,
    "inspiration_teen": 3,
    "regret_teen": 3,
    "boredom_teen": 2,
    "relief_teen": 4,
    "joy_ya": 4,
    "anger_ya": 1,
    "love_ya": 2,
    "fear_ya": 2,
    "excitement_ya": 3,
    "loneliness_ya": 3,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 3,
    "pleasure_ya": 4,
    "jealousy_ya": 4,
    "anxiety_ya": 3,
    "inspiration_ya": 4,
    "regret_ya": 4,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 1,
    "love_adult": 4,
    "fear_adult": 3,
    "excitement_adult": 4,
    "loneliness_adult": 3,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 3,
    "frustration_adult": 3,
    "pleasure_adult": 4,
    "jealousy_adult": 2,
    "anxiety_adult": 4,
    "inspiration_adult": 4,
    "regret_adult": 4,
    "boredom_adult": 3,
    "relief_adult": 4
  },
  "2": {
    "name": "Aurélien D",
    "age": 23,
    "joy_child": 1,
    "anger_child": 1,
    "love_child": 1,
    "fear_child": 1,
    "excitement_child": 1,
    "loneliness_child": 1,
    "shame_child": 1,
    "satisfaction_child": 1,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 1,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 1,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 2,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 4,
    "satisfaction_teen": 2,
    "sadness_teen": 4,
    "frustration_teen": 4,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": 3,
    "regret_teen": 5,
    "boredom_teen": 4,
    "relief_teen": 2,
    "joy_ya": 5,
    "anger_ya": 2,
    "love_ya": 5,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 1,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 1,
    "frustration_ya": 1,
    "pleasure_ya": 5,
    "jealousy_ya": 1,
    "anxiety_ya": 1,
    "inspiration_ya": 3,
    "regret_ya": 1,
    "boredom_ya": 1,
    "relief_ya": 1,
    "joy_adult": 3,
    "anger_adult": 4,
    "love_adult": 1,
    "fear_adult": 3,
    "excitement_adult": 5,
    "loneliness_adult": 5,
    "shame_adult": 2,
    "satisfaction_adult": 4,
    "sadness_adult": 3,
    "frustration_adult": 4,
    "pleasure_adult": 3,
    "jealousy_adult": 2,
    "anxiety_adult": 4,
    "inspiration_adult": 4,
    "regret_adult": 3,
    "boredom_adult": 3,
    "relief_adult": 2
  },
  "3": {
    "name": "Jessy",
    "age": 23,
    "joy_child": 4,
    "anger_child": 3,
    "love_child": 4,
    "fear_child": 3,
    "excitement_child": 2,
    "loneliness_child": 2,
    "shame_child": 3,
    "satisfaction_child": 4,
    "sadness_child": 4,
    "frustration_child": 3,
    "pleasure_child": 4,
    "jealousy_child": 3,
    "anxiety_child": 2,
    "inspiration_child": 4,
    "regret_child": 4,
    "boredom_child": 3,
    "relief_child": 2,
    "joy_teen": 4,
    "anger_teen": 4,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 4,
    "loneliness_teen": 2,
    "shame_teen": 4,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 3,
    "pleasure_teen": 3,
    "jealousy_teen": 4,
    "anxiety_teen": 4,
    "inspiration_teen": 4,
    "regret_teen": 4,
    "boredom_teen": 2,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 4,
    "love_ya": 3,
    "fear_ya": 4,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 3,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 4,
    "pleasure_ya": 4,
    "jealousy_ya": 3,
    "anxiety_ya": 4,
    "inspiration_ya": 3,
    "regret_ya": 4,
    "boredom_ya": 3,
    "relief_ya": 3,
    "joy_adult": 3,
    "anger_adult": 4,
    "love_adult": 2,
    "fear_adult": 4,
    "excitement_adult": 3,
    "loneliness_adult": 2,
    "shame_adult": 3,
    "satisfaction_adult": 3,
    "sadness_adult": 4,
    "frustration_adult": 4,
    "pleasure_adult": 3,
    "jealousy_adult": 2,
    "anxiety_adult": 5,
    "inspiration_adult": 4,
    "regret_adult": 4,
    "boredom_adult": 4,
    "relief_adult": 2
  },
  "4": {
    "name": "Antoine G",
    "age": 20,
    "joy_child": 5,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 2,
    "excitement_child": 4,
    "loneliness_child": 3,
    "shame_child": 1,
    "satisfaction_child": 4,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 4,
    "jealousy_child": 1,
    "anxiety_child": 2,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 4,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 2,
    "fear_teen": 4,
    "excitement_teen": 4,
    "loneliness_teen": 5,
    "shame_teen": 5,
    "satisfaction_teen": 4,
    "sadness_teen": 2,
    "frustration_teen": 4,
    "pleasure_teen": 4,
    "jealousy_teen": 5,
    "anxiety_teen": 4,
    "inspiration_teen": 3,
    "regret_teen": 2,
    "boredom_teen": 2,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 3,
    "love_ya": 2,
    "fear_ya": 3,
    "excitement_ya": 3,
    "loneliness_ya": 4,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 1,
    "frustration_ya": 4,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 1,
    "inspiration_ya": 4,
    "regret_ya": 1,
    "boredom_ya": 1,
    "relief_ya": 4,
    "joy_adult": 5,
    "anger_adult": 2,
    "love_adult": 1,
    "fear_adult": 1,
    "excitement_adult": 4,
    "loneliness_adult": 4,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 4,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 1,
    "inspiration_adult": 4,
    "regret_adult": 1,
    "boredom_adult": 1,
    "relief_adult": 5
  },
  "5": {
    "name": "Wendy",
    "age": 23,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 4,
    "fear_child": 4,
    "excitement_child": 3,
    "loneliness_child": 3,
    "shame_child": 4,
    "satisfaction_child": 3,
    "sadness_child": 3,
    "frustration_child": 3,
    "pleasure_child": 3,
    "jealousy_child": 2,
    "anxiety_child": 3,
    "inspiration_child": 2,
    "regret_child": 2,
    "boredom_child": 3,
    "relief_child": 3,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 3,
    "sadness_teen": 3,
    "frustration_teen": 3,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 3,
    "inspiration_teen": 2,
    "regret_teen": 2,
    "boredom_teen": 2,
    "relief_teen": 3,
    "joy_ya": 4,
    "anger_ya": 3,
    "love_ya": 3,
    "fear_ya": 3,
    "excitement_ya": 3,
    "loneliness_ya": 2,
    "shame_ya": 3,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 3,
    "pleasure_ya": 3,
    "jealousy_ya": 2,
    "anxiety_ya": 3,
    "inspiration_ya": 3,
    "regret_ya": 3,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 3,
    "love_adult": 4,
    "fear_adult": 3,
    "excitement_adult": 3,
    "loneliness_adult": 2,
    "shame_adult": 3,
    "satisfaction_adult": 4,
    "sadness_adult": 4,
    "frustration_adult": 3,
    "pleasure_adult": 4,
    "jealousy_adult": 3,
    "anxiety_adult": 3,
    "inspiration_adult": 4,
    "regret_adult": 4,
    "boredom_adult": 2,
    "relief_adult": 3
  },
  "6": {
    "name": "Stan",
    "age": 19,
    "joy_child": 5,
    "anger_child": 4,
    "love_child": 5,
    "fear_child": 3,
    "excitement_child": 5,
    "loneliness_child": 3,
    "shame_child": 4,
    "satisfaction_child": 1,
    "sadness_child": 2,
    "frustration_child": 3,
    "pleasure_child": 4,
    "jealousy_child": 1,
    "anxiety_child": 2,
    "inspiration_child": 5,
    "regret_child": 2,
    "boredom_child": 4,
    "relief_child": 3,
    "joy_teen": 4,
    "anger_teen": 4,
    "love_teen": 2,
    "fear_teen": 4,
    "excitement_teen": 3,
    "loneliness_teen": 3,
    "shame_teen": 5,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 4,
    "pleasure_teen": 3,
    "jealousy_teen": 3,
    "anxiety_teen": 2,
    "inspiration_teen": 5,
    "regret_teen": 4,
    "boredom_teen": 3,
    "relief_teen": null,
    "joy_ya": 4,
    "anger_ya": 4,
    "love_ya": 5,
    "fear_ya": 5,
    "excitement_ya": 3,
    "loneliness_ya": 5,
    "shame_ya": 5,
    "satisfaction_ya": 2,
    "sadness_ya": 5,
    "frustration_ya": 5,
    "pleasure_ya": 3,
    "jealousy_ya": 5,
    "anxiety_ya": 4,
    "inspiration_ya": 3,
    "regret_ya": 4,
    "boredom_ya": 4,
    "relief_ya": 2,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "7": {
    "name": "Anna Maria",
    "age": 20,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 1,
    "fear_child": 2,
    "excitement_child": 5,
    "loneliness_child": 4,
    "shame_child": 1,
    "satisfaction_child": 1,
    "sadness_child": 1,
    "frustration_child": 4,
    "pleasure_child": 1,
    "jealousy_child": 4,
    "anxiety_child": 3,
    "inspiration_child": 5,
    "regret_child": 2,
    "boredom_child": 4,
    "relief_child": 1,
    "joy_teen": 3,
    "anger_teen": 2,
    "love_teen": 2,
    "fear_teen": 1,
    "excitement_teen": 4,
    "loneliness_teen": 4,
    "shame_teen": 4,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 2,
    "pleasure_teen": 2,
    "jealousy_teen": 2,
    "anxiety_teen": 5,
    "inspiration_teen": 4,
    "regret_teen": 5,
    "boredom_teen": 4,
    "relief_teen": 1,
    "joy_ya": 4,
    "anger_ya": 1,
    "love_ya": 2,
    "fear_ya": 3,
    "excitement_ya": 5,
    "loneliness_ya": 2,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 2,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 3,
    "inspiration_ya": 5,
    "regret_ya": 1,
    "boredom_ya": 2,
    "relief_ya": 4,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "8": {
    "name": "Léna",
    "age": 23,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 4,
    "fear_child": 5,
    "excitement_child": 3,
    "loneliness_child": 4,
    "shame_child": 4,
    "satisfaction_child": 2,
    "sadness_child": 3,
    "frustration_child": 4,
    "pleasure_child": 4,
    "jealousy_child": 3,
    "anxiety_child": 4,
    "inspiration_child": 5,
    "regret_child": 2,
    "boredom_child": 5,
    "relief_child": 2,
    "joy_teen": 3,
    "anger_teen": 4,
    "love_teen": 4,
    "fear_teen": 4,
    "excitement_teen": 4,
    "loneliness_teen": 4,
    "shame_teen": 3,
    "satisfaction_teen": 2,
    "sadness_teen": 5,
    "frustration_teen": 5,
    "pleasure_teen": 4,
    "jealousy_teen": 2,
    "anxiety_teen": 5,
    "inspiration_teen": 5,
    "regret_teen": 3,
    "boredom_teen": 1,
    "relief_teen": 1,
    "joy_ya": 2,
    "anger_ya": 5,
    "love_ya": 4,
    "fear_ya": 5,
    "excitement_ya": 3,
    "loneliness_ya": 5,
    "shame_ya": 4,
    "satisfaction_ya": 1,
    "sadness_ya": 5,
    "frustration_ya": 5,
    "pleasure_ya": 2,
    "jealousy_ya": 1,
    "anxiety_ya": 5,
    "inspiration_ya": 3,
    "regret_ya": 5,
    "boredom_ya": 1,
    "relief_ya": 1,
    "joy_adult": 5,
    "anger_adult": 4,
    "love_adult": 5,
    "fear_adult": 3,
    "excitement_adult": 5,
    "loneliness_adult": 4,
    "shame_adult": 2,
    "satisfaction_adult": 4,
    "sadness_adult": 3,
    "frustration_adult": 4,
    "pleasure_adult": 5,
    "jealousy_adult": 1,
    "anxiety_adult": 3,
    "inspiration_adult": 3,
    "regret_adult": 1,
    "boredom_adult": 1,
    "relief_adult": 5
  },
  "9": {
    "name": "Anonyme",
    "age": 21,
    "joy_child": 5,
    "anger_child": 1,
    "love_child": 3,
    "fear_child": 1,
    "excitement_child": 3,
    "loneliness_child": 1,
    "shame_child": 4,
    "satisfaction_child": 3,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 4,
    "jealousy_child": 1,
    "anxiety_child": 5,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 3,
    "relief_child": 3,
    "joy_teen": 4,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 1,
    "excitement_teen": 2,
    "loneliness_teen": 2,
    "shame_teen": 5,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 1,
    "pleasure_teen": 3,
    "jealousy_teen": 1,
    "anxiety_teen": 5,
    "inspiration_teen": 3,
    "regret_teen": 1,
    "boredom_teen": 5,
    "relief_teen": 1,
    "joy_ya": 4,
    "anger_ya": 1,
    "love_ya": 5,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 1,
    "shame_ya": 4,
    "satisfaction_ya": 3,
    "sadness_ya": 1,
    "frustration_ya": 1,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 5,
    "inspiration_ya": 3,
    "regret_ya": 1,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 5,
    "anger_adult": 1,
    "love_adult": 5,
    "fear_adult": 1,
    "excitement_adult": 5,
    "loneliness_adult": 1,
    "shame_adult": 2,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 5,
    "inspiration_adult": 4,
    "regret_adult": 1,
    "boredom_adult": 1,
    "relief_adult": 4
  },
  "10": {
    "name": "Anonyme",
    "age": 23,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 1,
    "fear_child": 1,
    "excitement_child": 3,
    "loneliness_child": 1,
    "shame_child": 2,
    "satisfaction_child": 3,
    "sadness_child": 3,
    "frustration_child": 3,
    "pleasure_child": 5,
    "jealousy_child": 2,
    "anxiety_child": 2,
    "inspiration_child": 4,
    "regret_child": 1,
    "boredom_child": 2,
    "relief_child": 3,
    "joy_teen": 2,
    "anger_teen": 4,
    "love_teen": 4,
    "fear_teen": 5,
    "excitement_teen": 2,
    "loneliness_teen": 3,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 5,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 5,
    "inspiration_teen": 3,
    "regret_teen": 5,
    "boredom_teen": 1,
    "relief_teen": 2,
    "joy_ya": 3,
    "anger_ya": 3,
    "love_ya": 4,
    "fear_ya": 2,
    "excitement_ya": 3,
    "loneliness_ya": 4,
    "shame_ya": 1,
    "satisfaction_ya": 3,
    "sadness_ya": 3,
    "frustration_ya": 2,
    "pleasure_ya": 4,
    "jealousy_ya": 3,
    "anxiety_ya": 4,
    "inspiration_ya": 3,
    "regret_ya": 4,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 3,
    "love_adult": 5,
    "fear_adult": 3,
    "excitement_adult": 4,
    "loneliness_adult": 3,
    "shame_adult": 1,
    "satisfaction_adult": 3,
    "sadness_adult": 3,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 3,
    "anxiety_adult": 2,
    "inspiration_adult": 4,
    "regret_adult": 2,
    "boredom_adult": 1,
    "relief_adult": 1
  },
  "11": {
    "name": "Jimmy",
    "age": 21,
    "joy_child": 5,
    "anger_child": 1,
    "love_child": 5,
    "fear_child": 3,
    "excitement_child": 5,
    "loneliness_child": 1,
    "shame_child": 1,
    "satisfaction_child": 5,
    "sadness_child": 3,
    "frustration_child": 2,
    "pleasure_child": 5,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 2,
    "relief_child": 3,
    "joy_teen": 4,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 2,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 3,
    "sadness_teen": 1,
    "frustration_teen": 1,
    "pleasure_teen": 3,
    "jealousy_teen": 1,
    "anxiety_teen": 1,
    "inspiration_teen": 5,
    "regret_teen": 1,
    "boredom_teen": 2,
    "relief_teen": 5,
    "joy_ya": 4,
    "anger_ya": 3,
    "love_ya": 4,
    "fear_ya": 1,
    "excitement_ya": 5,
    "loneliness_ya": 2,
    "shame_ya": 1,
    "satisfaction_ya": 3,
    "sadness_ya": 1,
    "frustration_ya": 1,
    "pleasure_ya": 3,
    "jealousy_ya": 1,
    "anxiety_ya": 1,
    "inspiration_ya": 5,
    "regret_ya": 1,
    "boredom_ya": 3,
    "relief_ya": 1,
    "joy_adult": 3,
    "anger_adult": 5,
    "love_adult": 1,
    "fear_adult": 1,
    "excitement_adult": 1,
    "loneliness_adult": 5,
    "shame_adult": 1,
    "satisfaction_adult": 3,
    "sadness_adult": 1,
    "frustration_adult": 3,
    "pleasure_adult": 3,
    "jealousy_adult": 1,
    "anxiety_adult": 1,
    "inspiration_adult": 5,
    "regret_adult": 1,
    "boredom_adult": 2,
    "relief_adult": 1
  },
  "12": {
    "name": "Louise",
    "age": 21,
    "joy_child": 5,
    "anger_child": 1,
    "love_child": 4,
    "fear_child": 3,
    "excitement_child": 5,
    "loneliness_child": 1,
    "shame_child": 2,
    "satisfaction_child": 4,
    "sadness_child": 1,
    "frustration_child": 2,
    "pleasure_child": 4,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 4,
    "regret_child": 1,
    "boredom_child": 3,
    "relief_child": 3,
    "joy_teen": 3,
    "anger_teen": 2,
    "love_teen": 3,
    "fear_teen": 4,
    "excitement_teen": 4,
    "loneliness_teen": 5,
    "shame_teen": 4,
    "satisfaction_teen": 3,
    "sadness_teen": 4,
    "frustration_teen": 5,
    "pleasure_teen": 3,
    "jealousy_teen": 3,
    "anxiety_teen": 4,
    "inspiration_teen": 2,
    "regret_teen": 3,
    "boredom_teen": 2,
    "relief_teen": 2,
    "joy_ya": 5,
    "anger_ya": 4,
    "love_ya": 5,
    "fear_ya": 5,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 4,
    "satisfaction_ya": 3,
    "sadness_ya": 3,
    "frustration_ya": 3,
    "pleasure_ya": 4,
    "jealousy_ya": 4,
    "anxiety_ya": 5,
    "inspiration_ya": 4,
    "regret_ya": 3,
    "boredom_ya": 1,
    "relief_ya": 4,
    "joy_adult": 5,
    "anger_adult": 4,
    "love_adult": 5,
    "fear_adult": 2,
    "excitement_adult": 4,
    "loneliness_adult": 2,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 4,
    "anxiety_adult": 4,
    "inspiration_adult": 3,
    "regret_adult": 2,
    "boredom_adult": 1,
    "relief_adult": 3
  },
  "13": {
    "name": "Anonyme",
    "age": 20,
    "joy_child": 5,
    "anger_child": 2,
    "love_child": 4,
    "fear_child": 3,
    "excitement_child": 3,
    "loneliness_child": 3,
    "shame_child": 4,
    "satisfaction_child": 5,
    "sadness_child": 2,
    "frustration_child": 1,
    "pleasure_child": 5,
    "jealousy_child": 1,
    "anxiety_child": 3,
    "inspiration_child": 2,
    "regret_child": 2,
    "boredom_child": 1,
    "relief_child": 4,
    "joy_teen": 4,
    "anger_teen": 2,
    "love_teen": 3,
    "fear_teen": 2,
    "excitement_teen": 3,
    "loneliness_teen": 5,
    "shame_teen": 2,
    "satisfaction_teen": 4,
    "sadness_teen": 3,
    "frustration_teen": 3,
    "pleasure_teen": 4,
    "jealousy_teen": 1,
    "anxiety_teen": 2,
    "inspiration_teen": 2,
    "regret_teen": 3,
    "boredom_teen": 1,
    "relief_teen": 4,
    "joy_ya": 4,
    "anger_ya": 3,
    "love_ya": 4,
    "fear_ya": 3,
    "excitement_ya": 2,
    "loneliness_ya": 2,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 4,
    "frustration_ya": 4,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 4,
    "inspiration_ya": 1,
    "regret_ya": 5,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 4,
    "love_adult": 4,
    "fear_adult": 4,
    "excitement_adult": 2,
    "loneliness_adult": 4,
    "shame_adult": 4,
    "satisfaction_adult": 2,
    "sadness_adult": 4,
    "frustration_adult": 4,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 5,
    "inspiration_adult": 1,
    "regret_adult": 5,
    "boredom_adult": 1,
    "relief_adult": 3
  },
  "14": {
    "name": "Lina",
    "age": 20,
    "joy_child": 5,
    "anger_child": 1,
    "love_child": 4,
    "fear_child": 2,
    "excitement_child": 5,
    "loneliness_child": 1,
    "shame_child": 2,
    "satisfaction_child": 4,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 5,
    "jealousy_child": 1,
    "anxiety_child": 2,
    "inspiration_child": 2,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 4,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 1,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 3,
    "sadness_teen": 2,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": 2,
    "regret_teen": 1,
    "boredom_teen": 4,
    "relief_teen": 3,
    "joy_ya": 4,
    "anger_ya": 1,
    "love_ya": 4,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 3,
    "satisfaction_ya": 4,
    "sadness_ya": 4,
    "frustration_ya": 4,
    "pleasure_ya": 4,
    "jealousy_ya": 2,
    "anxiety_ya": 4,
    "inspiration_ya": 4,
    "regret_ya": 2,
    "boredom_ya": 4,
    "relief_ya": 3,
    "joy_adult": 5,
    "anger_adult": 1,
    "love_adult": 4,
    "fear_adult": 2,
    "excitement_adult": 4,
    "loneliness_adult": 2,
    "shame_adult": 2,
    "satisfaction_adult": 2,
    "sadness_adult": 3,
    "frustration_adult": 4,
    "pleasure_adult": 4,
    "jealousy_adult": 2,
    "anxiety_adult": 3,
    "inspiration_adult": 3,
    "regret_adult": 1,
    "boredom_adult": 3,
    "relief_adult": 2
  },
  "15": {
    "name": "Anonyme",
    "age": 20,
    "joy_child": 5,
    "anger_child": 5,
    "love_child": 5,
    "fear_child": 5,
    "excitement_child": 5,
    "loneliness_child": 5,
    "shame_child": 5,
    "satisfaction_child": 5,
    "sadness_child": 5,
    "frustration_child": 4,
    "pleasure_child": 5,
    "jealousy_child": 4,
    "anxiety_child": 5,
    "inspiration_child": 5,
    "regret_child": 5,
    "boredom_child": 5,
    "relief_child": 5,
    "joy_teen": 5,
    "anger_teen": 5,
    "love_teen": 4,
    "fear_teen": 3,
    "excitement_teen": 4,
    "loneliness_teen": 5,
    "shame_teen": 5,
    "satisfaction_teen": 4,
    "sadness_teen": 5,
    "frustration_teen": 4,
    "pleasure_teen": 4,
    "jealousy_teen": 3,
    "anxiety_teen": 5,
    "inspiration_teen": 4,
    "regret_teen": 3,
    "boredom_teen": 4,
    "relief_teen": 5,
    "joy_ya": 3,
    "anger_ya": 2,
    "love_ya": 5,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 3,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 2,
    "frustration_ya": 4,
    "pleasure_ya": 4,
    "jealousy_ya": 2,
    "anxiety_ya": 4,
    "inspiration_ya": 4,
    "regret_ya": 2,
    "boredom_ya": 3,
    "relief_ya": 4,
    "joy_adult": 3,
    "anger_adult": 1,
    "love_adult": 3,
    "fear_adult": 1,
    "excitement_adult": 4,
    "loneliness_adult": 3,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 4,
    "pleasure_adult": 3,
    "jealousy_adult": 1,
    "anxiety_adult": 4,
    "inspiration_adult": 3,
    "regret_adult": 1,
    "boredom_adult": 2,
    "relief_adult": 3
  },
  "16": {
    "name": "Thomas",
    "age": 36,
    "joy_child": 2,
    "anger_child": 5,
    "love_child": 1,
    "fear_child": 4,
    "excitement_child": 2,
    "loneliness_child": 5,
    "shame_child": 1,
    "satisfaction_child": 1,
    "sadness_child": 4,
    "frustration_child": 4,
    "pleasure_child": 1,
    "jealousy_child": 3,
    "anxiety_child": 3,
    "inspiration_child": 5,
    "regret_child": 1,
    "boredom_child": 5,
    "relief_child": 1,
    "joy_teen": 3,
    "anger_teen": 4,
    "love_teen": 5,
    "fear_teen": 2,
    "excitement_teen": 4,
    "loneliness_teen": 1,
    "shame_teen": 3,
    "satisfaction_teen": 1,
    "sadness_teen": 1,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": 4,
    "regret_teen": 1,
    "boredom_teen": 2,
    "relief_teen": 1,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 4,
    "fear_ya": 1,
    "excitement_ya": 2,
    "loneliness_ya": 1,
    "shame_ya": 1,
    "satisfaction_ya": 3,
    "sadness_ya": 2,
    "frustration_ya": 4,
    "pleasure_ya": 5,
    "jealousy_ya": 1,
    "anxiety_ya": null,
    "inspiration_ya": null,
    "regret_ya": 2,
    "boredom_ya": null,
    "relief_ya": 2,
    "joy_adult": 5,
    "anger_adult": 1,
    "love_adult": 5,
    "fear_adult": 2,
    "excitement_adult": 4,
    "loneliness_adult": 3,
    "shame_adult": 1,
    "satisfaction_adult": 3,
    "sadness_adult": 1,
    "frustration_adult": 1,
    "pleasure_adult": 5,
    "jealousy_adult": 1,
    "anxiety_adult": 1,
    "inspiration_adult": 2,
    "regret_adult": 1,
    "boredom_adult": 1,
    "relief_adult": 2
  },
  "17": {
    "name": "Anonyme",
    "age": 22,
    "joy_child": 5,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 4,
    "excitement_child": 4,
    "loneliness_child": 3,
    "shame_child": 1,
    "satisfaction_child": 5,
    "sadness_child": 3,
    "frustration_child": 5,
    "pleasure_child": 5,
    "jealousy_child": 5,
    "anxiety_child": 2,
    "inspiration_child": 5,
    "regret_child": 2,
    "boredom_child": 3,
    "relief_child": 1,
    "joy_teen": 5,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 4,
    "excitement_teen": 5,
    "loneliness_teen": 1,
    "shame_teen": 3,
    "satisfaction_teen": 5,
    "sadness_teen": 2,
    "frustration_teen": 3,
    "pleasure_teen": 5,
    "jealousy_teen": 3,
    "anxiety_teen": 4,
    "inspiration_teen": 3,
    "regret_teen": 1,
    "boredom_teen": 1,
    "relief_teen": 1,
    "joy_ya": 3,
    "anger_ya": 5,
    "love_ya": 1,
    "fear_ya": 2,
    "excitement_ya": 3,
    "loneliness_ya": 2,
    "shame_ya": 2,
    "satisfaction_ya": 3,
    "sadness_ya": 4,
    "frustration_ya": 2,
    "pleasure_ya": 3,
    "jealousy_ya": 2,
    "anxiety_ya": 5,
    "inspiration_ya": 4,
    "regret_ya": 4,
    "boredom_ya": 2,
    "relief_ya": 4,
    "joy_adult": 2,
    "anger_adult": 4,
    "love_adult": 5,
    "fear_adult": 5,
    "excitement_adult": 2,
    "loneliness_adult": 4,
    "shame_adult": 5,
    "satisfaction_adult": 2,
    "sadness_adult": 5,
    "frustration_adult": 3,
    "pleasure_adult": 3,
    "jealousy_adult": 3,
    "anxiety_adult": 5,
    "inspiration_adult": 3,
    "regret_adult": 5,
    "boredom_adult": 4,
    "relief_adult": 1
  },
  "18": {
    "name": "Christelle",
    "age": 26,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 3,
    "excitement_child": 3,
    "loneliness_child": 1,
    "shame_child": 3,
    "satisfaction_child": 3,
    "sadness_child": 2,
    "frustration_child": 2,
    "pleasure_child": 3,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 2,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 2,
    "excitement_teen": 2,
    "loneliness_teen": 1,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 3,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 1,
    "anxiety_teen": 2,
    "inspiration_teen": 3,
    "regret_teen": 2,
    "boredom_teen": 1,
    "relief_teen": 2,
    "joy_ya": 5,
    "anger_ya": 3,
    "love_ya": 5,
    "fear_ya": 3,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 2,
    "frustration_ya": 2,
    "pleasure_ya": 3,
    "jealousy_ya": 1,
    "anxiety_ya": 3,
    "inspiration_ya": 4,
    "regret_ya": 3,
    "boredom_ya": 1,
    "relief_ya": 3,
    "joy_adult": 3,
    "anger_adult": 1,
    "love_adult": 2,
    "fear_adult": 2,
    "excitement_adult": 3,
    "loneliness_adult": 4,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 3,
    "frustration_adult": 2,
    "pleasure_adult": 3,
    "jealousy_adult": 1,
    "anxiety_adult": 3,
    "inspiration_adult": 4,
    "regret_adult": 3,
    "boredom_adult": 1,
    "relief_adult": 3
  },
  "19": {
    "name": "Lucien",
    "age": 20,
    "joy_child": 5,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 2,
    "excitement_child": 4,
    "loneliness_child": 1,
    "shame_child": 1,
    "satisfaction_child": 4,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 4,
    "jealousy_child": 4,
    "anxiety_child": 1,
    "inspiration_child": 2,
    "regret_child": 1,
    "boredom_child": 4,
    "relief_child": 3,
    "joy_teen": 3,
    "anger_teen": 2,
    "love_teen": 1,
    "fear_teen": 4,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 5,
    "satisfaction_teen": 2,
    "sadness_teen": 4,
    "frustration_teen": 4,
    "pleasure_teen": 2,
    "jealousy_teen": 1,
    "anxiety_teen": 2,
    "inspiration_teen": 1,
    "regret_teen": 5,
    "boredom_teen": 3,
    "relief_teen": 2,
    "joy_ya": 3,
    "anger_ya": 1,
    "love_ya": 5,
    "fear_ya": 4,
    "excitement_ya": 1,
    "loneliness_ya": 4,
    "shame_ya": 2,
    "satisfaction_ya": 3,
    "sadness_ya": 5,
    "frustration_ya": 3,
    "pleasure_ya": 5,
    "jealousy_ya": 3,
    "anxiety_ya": 5,
    "inspiration_ya": 2,
    "regret_ya": 5,
    "boredom_ya": 2,
    "relief_ya": 2,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "20": {
    "name": "Thabian",
    "age": 20,
    "joy_child": 5,
    "anger_child": 1,
    "love_child": 5,
    "fear_child": 3,
    "excitement_child": 3,
    "loneliness_child": 4,
    "shame_child": 5,
    "satisfaction_child": 5,
    "sadness_child": 3,
    "frustration_child": 1,
    "pleasure_child": 5,
    "jealousy_child": 1,
    "anxiety_child": 4,
    "inspiration_child": 5,
    "regret_child": 1,
    "boredom_child": 4,
    "relief_child": 3,
    "joy_teen": 4,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 4,
    "shame_teen": 3,
    "satisfaction_teen": 5,
    "sadness_teen": 3,
    "frustration_teen": 1,
    "pleasure_teen": 4,
    "jealousy_teen": 1,
    "anxiety_teen": 3,
    "inspiration_teen": 4,
    "regret_teen": 1,
    "boredom_teen": 3,
    "relief_teen": 3,
    "joy_ya": 5,
    "anger_ya": 1,
    "love_ya": 4,
    "fear_ya": 3,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 1,
    "frustration_ya": 1,
    "pleasure_ya": 5,
    "jealousy_ya": 1,
    "anxiety_ya": 2,
    "inspiration_ya": 5,
    "regret_ya": 1,
    "boredom_ya": 1,
    "relief_ya": 3,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "21": {
    "name": "Jahnoy",
    "age": 22,
    "joy_child": 3,
    "anger_child": 3,
    "love_child": 2,
    "fear_child": 2,
    "excitement_child": 3,
    "loneliness_child": 3,
    "shame_child": 3,
    "satisfaction_child": 2,
    "sadness_child": 2,
    "frustration_child": 2,
    "pleasure_child": 3,
    "jealousy_child": 1,
    "anxiety_child": 2,
    "inspiration_child": 4,
    "regret_child": 2,
    "boredom_child": 2,
    "relief_child": 4,
    "joy_teen": 2,
    "anger_teen": 4,
    "love_teen": 4,
    "fear_teen": 3,
    "excitement_teen": 2,
    "loneliness_teen": 3,
    "shame_teen": 4,
    "satisfaction_teen": 5,
    "sadness_teen": 3,
    "frustration_teen": 4,
    "pleasure_teen": 2,
    "jealousy_teen": 3,
    "anxiety_teen": 4,
    "inspiration_teen": 5,
    "regret_teen": 3,
    "boredom_teen": 4,
    "relief_teen": 4,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 4,
    "fear_ya": 2,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 2,
    "pleasure_ya": 3,
    "jealousy_ya": 3,
    "anxiety_ya": 4,
    "inspiration_ya": 5,
    "regret_ya": 3,
    "boredom_ya": 3,
    "relief_ya": 5,
    "joy_adult": 4,
    "anger_adult": 1,
    "love_adult": 5,
    "fear_adult": 1,
    "excitement_adult": 5,
    "loneliness_adult": 1,
    "shame_adult": 1,
    "satisfaction_adult": 3,
    "sadness_adult": 2,
    "frustration_adult": 4,
    "pleasure_adult": 4,
    "jealousy_adult": 2,
    "anxiety_adult": 2,
    "inspiration_adult": 5,
    "regret_adult": 3,
    "boredom_adult": 2,
    "relief_adult": 2
  },
  "22": {
    "name": "Chanel",
    "age": 20,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 1,
    "fear_child": 3,
    "excitement_child": 3,
    "loneliness_child": 4,
    "shame_child": 3,
    "satisfaction_child": 3,
    "sadness_child": 2,
    "frustration_child": 2,
    "pleasure_child": 3,
    "jealousy_child": 4,
    "anxiety_child": 3,
    "inspiration_child": 2,
    "regret_child": 3,
    "boredom_child": 4,
    "relief_child": 3,
    "joy_teen": 3,
    "anger_teen": 4,
    "love_teen": 2,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 3,
    "sadness_teen": 4,
    "frustration_teen": 4,
    "pleasure_teen": 4,
    "jealousy_teen": 4,
    "anxiety_teen": 3,
    "inspiration_teen": 2,
    "regret_teen": 2,
    "boredom_teen": 3,
    "relief_teen": 3,
    "joy_ya": 5,
    "anger_ya": 3,
    "love_ya": 5,
    "fear_ya": 2,
    "excitement_ya": 4,
    "loneliness_ya": 1,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 1,
    "frustration_ya": 1,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 1,
    "inspiration_ya": 4,
    "regret_ya": 1,
    "boredom_ya": 1,
    "relief_ya": 5,
    "joy_adult": 5,
    "anger_adult": 1,
    "love_adult": 5,
    "fear_adult": 1,
    "excitement_adult": 5,
    "loneliness_adult": 1,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 1,
    "frustration_adult": 3,
    "pleasure_adult": 5,
    "jealousy_adult": 2,
    "anxiety_adult": 1,
    "inspiration_adult": 4,
    "regret_adult": 4,
    "boredom_adult": 4,
    "relief_adult": 5
  },
  "23": {
    "name": "Vincent",
    "age": 20,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 3,
    "fear_child": 4,
    "excitement_child": 3,
    "loneliness_child": 2,
    "shame_child": 3,
    "satisfaction_child": 2,
    "sadness_child": 1,
    "frustration_child": 4,
    "pleasure_child": 3,
    "jealousy_child": 1,
    "anxiety_child": 3,
    "inspiration_child": 4,
    "regret_child": 1,
    "boredom_child": 2,
    "relief_child": 3,
    "joy_teen": 3,
    "anger_teen": 3,
    "love_teen": 4,
    "fear_teen": 2,
    "excitement_teen": 4,
    "loneliness_teen": 3,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 2,
    "frustration_teen": 3,
    "pleasure_teen": 4,
    "jealousy_teen": 2,
    "anxiety_teen": 2,
    "inspiration_teen": 3,
    "regret_teen": 3,
    "boredom_teen": 4,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 4,
    "fear_ya": 2,
    "excitement_ya": 3,
    "loneliness_ya": 3,
    "shame_ya": 2,
    "satisfaction_ya": 3,
    "sadness_ya": 2,
    "frustration_ya": 2,
    "pleasure_ya": 4,
    "jealousy_ya": 2,
    "anxiety_ya": 2,
    "inspiration_ya": 4,
    "regret_ya": 3,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 3,
    "love_adult": 4,
    "fear_adult": 2,
    "excitement_adult": 3,
    "loneliness_adult": 2,
    "shame_adult": 2,
    "satisfaction_adult": 3,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 1,
    "inspiration_adult": 4,
    "regret_adult": 3,
    "boredom_adult": 1,
    "relief_adult": 3
  },
  "24": {
    "name": "Clément B",
    "age": 21,
    "joy_child": 5,
    "anger_child": 4,
    "love_child": 5,
    "fear_child": 2,
    "excitement_child": 4,
    "loneliness_child": 2,
    "shame_child": 5,
    "satisfaction_child": 5,
    "sadness_child": 1,
    "frustration_child": 1,
    "pleasure_child": 5,
    "jealousy_child": 2,
    "anxiety_child": 1,
    "inspiration_child": 5,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 5,
    "joy_teen": 4,
    "anger_teen": 5,
    "love_teen": 4,
    "fear_teen": 2,
    "excitement_teen": 3,
    "loneliness_teen": 3,
    "shame_teen": 4,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 4,
    "pleasure_teen": 3,
    "jealousy_teen": 4,
    "anxiety_teen": 3,
    "inspiration_teen": 2,
    "regret_teen": 5,
    "boredom_teen": 3,
    "relief_teen": null,
    "joy_ya": 3,
    "anger_ya": 3,
    "love_ya": 2,
    "fear_ya": 4,
    "excitement_ya": 3,
    "loneliness_ya": 4,
    "shame_ya": 4,
    "satisfaction_ya": 3,
    "sadness_ya": 4,
    "frustration_ya": 3,
    "pleasure_ya": 2,
    "jealousy_ya": 4,
    "anxiety_ya": 3,
    "inspiration_ya": 5,
    "regret_ya": 1,
    "boredom_ya": 2,
    "relief_ya": null,
    "joy_adult": 3,
    "anger_adult": 2,
    "love_adult": 4,
    "fear_adult": 3,
    "excitement_adult": 5,
    "loneliness_adult": 5,
    "shame_adult": 2,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 3,
    "inspiration_adult": 4,
    "regret_adult": 1,
    "boredom_adult": 2,
    "relief_adult": 3
  },
  "25": {
    "name": "Theo",
    "age": 21,
    "joy_child": 4,
    "anger_child": 5,
    "love_child": 3,
    "fear_child": 1,
    "excitement_child": 5,
    "loneliness_child": 2,
    "shame_child": 4,
    "satisfaction_child": 3,
    "sadness_child": 2,
    "frustration_child": 5,
    "pleasure_child": 5,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 3,
    "regret_child": 1,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 3,
    "anger_teen": 5,
    "love_teen": 1,
    "fear_teen": 4,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 3,
    "sadness_teen": 1,
    "frustration_teen": 4,
    "pleasure_teen": 4,
    "jealousy_teen": 1,
    "anxiety_teen": 1,
    "inspiration_teen": 4,
    "regret_teen": 1,
    "boredom_teen": 2,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 4,
    "fear_ya": 3,
    "excitement_ya": 4,
    "loneliness_ya": 1,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 3,
    "pleasure_ya": 4,
    "jealousy_ya": 2,
    "anxiety_ya": 5,
    "inspiration_ya": 5,
    "regret_ya": 4,
    "boredom_ya": 1,
    "relief_ya": 2,
    "joy_adult": 2,
    "anger_adult": 5,
    "love_adult": 5,
    "fear_adult": 5,
    "excitement_adult": 3,
    "loneliness_adult": 3,
    "shame_adult": 2,
    "satisfaction_adult": 2,
    "sadness_adult": 5,
    "frustration_adult": 5,
    "pleasure_adult": 3,
    "jealousy_adult": 5,
    "anxiety_adult": 5,
    "inspiration_adult": 4,
    "regret_adult": 5,
    "boredom_adult": 3,
    "relief_adult": 1
  },
  "26": {
    "name": "Clément R",
    "age": 20,
    "joy_child": 3,
    "anger_child": 1,
    "love_child": 2,
    "fear_child": 1,
    "excitement_child": 1,
    "loneliness_child": 4,
    "shame_child": 3,
    "satisfaction_child": 2,
    "sadness_child": 4,
    "frustration_child": 3,
    "pleasure_child": 2,
    "jealousy_child": 1,
    "anxiety_child": 4,
    "inspiration_child": 1,
    "regret_child": 1,
    "boredom_child": 4,
    "relief_child": 1,
    "joy_teen": 2,
    "anger_teen": 1,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 2,
    "loneliness_teen": 4,
    "shame_teen": 2,
    "satisfaction_teen": null,
    "sadness_teen": 5,
    "frustration_teen": 4,
    "pleasure_teen": 2,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": 1,
    "regret_teen": 1,
    "boredom_teen": 4,
    "relief_teen": 2,
    "joy_ya": 5,
    "anger_ya": 1,
    "love_ya": 4,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 2,
    "shame_ya": 1,
    "satisfaction_ya": 5,
    "sadness_ya": 1,
    "frustration_ya": 3,
    "pleasure_ya": 5,
    "jealousy_ya": 1,
    "anxiety_ya": 1,
    "inspiration_ya": 4,
    "regret_ya": 1,
    "boredom_ya": 3,
    "relief_ya": 5,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "27": {
    "name": "Victor S",
    "age": 22,
    "joy_child": 2,
    "anger_child": 1,
    "love_child": 1,
    "fear_child": 2,
    "excitement_child": 1,
    "loneliness_child": 4,
    "shame_child": 3,
    "satisfaction_child": 3,
    "sadness_child": 2,
    "frustration_child": 1,
    "pleasure_child": 1,
    "jealousy_child": 2,
    "anxiety_child": 1,
    "inspiration_child": 1,
    "regret_child": 2,
    "boredom_child": 4,
    "relief_child": 3,
    "joy_teen": 2,
    "anger_teen": 2,
    "love_teen": 1,
    "fear_teen": 3,
    "excitement_teen": 2,
    "loneliness_teen": 3,
    "shame_teen": 4,
    "satisfaction_teen": 3,
    "sadness_teen": 3,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 4,
    "anxiety_teen": 2,
    "inspiration_teen": 5,
    "regret_teen": 4,
    "boredom_teen": 4,
    "relief_teen": 2,
    "joy_ya": 3,
    "anger_ya": 1,
    "love_ya": 1,
    "fear_ya": 2,
    "excitement_ya": 3,
    "loneliness_ya": 2,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 2,
    "frustration_ya": 2,
    "pleasure_ya": 3,
    "jealousy_ya": 1,
    "anxiety_ya": 3,
    "inspiration_ya": 3,
    "regret_ya": 2,
    "boredom_ya": 3,
    "relief_ya": 2,
    "joy_adult": 4,
    "anger_adult": 1,
    "love_adult": 1,
    "fear_adult": 1,
    "excitement_adult": 4,
    "loneliness_adult": 1,
    "shame_adult": 1,
    "satisfaction_adult": 5,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 2,
    "inspiration_adult": 4,
    "regret_adult": 1,
    "boredom_adult": 2,
    "relief_adult": 3
  },
  "28": {
    "name": "Edward",
    "age": 20,
    "joy_child": 5,
    "anger_child": 4,
    "love_child": 2,
    "fear_child": 4,
    "excitement_child": 4,
    "loneliness_child": 1,
    "shame_child": 3,
    "satisfaction_child": 4,
    "sadness_child": 2,
    "frustration_child": 3,
    "pleasure_child": 5,
    "jealousy_child": 4,
    "anxiety_child": 1,
    "inspiration_child": 4,
    "regret_child": 2,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 1,
    "excitement_teen": 3,
    "loneliness_teen": 2,
    "shame_teen": 4,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 4,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 1,
    "inspiration_teen": 3,
    "regret_teen": 4,
    "boredom_teen": 2,
    "relief_teen": 3,
    "joy_ya": 3,
    "anger_ya": 1,
    "love_ya": 2,
    "fear_ya": 1,
    "excitement_ya": 3,
    "loneliness_ya": 3,
    "shame_ya": 2,
    "satisfaction_ya": 3,
    "sadness_ya": 4,
    "frustration_ya": 2,
    "pleasure_ya": 2,
    "jealousy_ya": 1,
    "anxiety_ya": 3,
    "inspiration_ya": 3,
    "regret_ya": 3,
    "boredom_ya": 2,
    "relief_ya": 1,
    "joy_adult": 3,
    "anger_adult": 2,
    "love_adult": 2,
    "fear_adult": 1,
    "excitement_adult": 2,
    "loneliness_adult": 3,
    "shame_adult": 2,
    "satisfaction_adult": 3,
    "sadness_adult": 3,
    "frustration_adult": 1,
    "pleasure_adult": 2,
    "jealousy_adult": 1,
    "anxiety_adult": 3,
    "inspiration_adult": 4,
    "regret_adult": 4,
    "boredom_adult": 3,
    "relief_adult": 2
  },
  "29": {
    "name": "Nicolas",
    "age": 22,
    "joy_child": 3,
    "anger_child": 1,
    "love_child": 2,
    "fear_child": 4,
    "excitement_child": 2,
    "loneliness_child": 3,
    "shame_child": 2,
    "satisfaction_child": 2,
    "sadness_child": 2,
    "frustration_child": 3,
    "pleasure_child": 2,
    "jealousy_child": 2,
    "anxiety_child": 4,
    "inspiration_child": null,
    "regret_child": 3,
    "boredom_child": 3,
    "relief_child": 3,
    "joy_teen": 3,
    "anger_teen": 1,
    "love_teen": 2,
    "fear_teen": 3,
    "excitement_teen": 3,
    "loneliness_teen": 3,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 2,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": null,
    "regret_teen": 2,
    "boredom_teen": 3,
    "relief_teen": 3,
    "joy_ya": 4,
    "anger_ya": 1,
    "love_ya": 4,
    "fear_ya": 2,
    "excitement_ya": 4,
    "loneliness_ya": 3,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 2,
    "frustration_ya": 2,
    "pleasure_ya": 4,
    "jealousy_ya": 2,
    "anxiety_ya": 3,
    "inspiration_ya": null,
    "regret_ya": 2,
    "boredom_ya": 2,
    "relief_ya": 4,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "30": {
    "name": "Antoine D",
    "age": 21,
    "joy_child": 3,
    "anger_child": 2,
    "love_child": 1,
    "fear_child": 4,
    "excitement_child": 1,
    "loneliness_child": 3,
    "shame_child": 3,
    "satisfaction_child": 2,
    "sadness_child": 5,
    "frustration_child": 1,
    "pleasure_child": 3,
    "jealousy_child": 1,
    "anxiety_child": 1,
    "inspiration_child": 1,
    "regret_child": 2,
    "boredom_child": 1,
    "relief_child": 1,
    "joy_teen": 2,
    "anger_teen": 3,
    "love_teen": 4,
    "fear_teen": 4,
    "excitement_teen": 2,
    "loneliness_teen": 4,
    "shame_teen": 2,
    "satisfaction_teen": 2,
    "sadness_teen": 4,
    "frustration_teen": 3,
    "pleasure_teen": 4,
    "jealousy_teen": 2,
    "anxiety_teen": 3,
    "inspiration_teen": 2,
    "regret_teen": 4,
    "boredom_teen": 3,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 5,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 3,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 4,
    "frustration_ya": 2,
    "pleasure_ya": 4,
    "jealousy_ya": 1,
    "anxiety_ya": 3,
    "inspiration_ya": 3,
    "regret_ya": 5,
    "boredom_ya": 2,
    "relief_ya": 3,
    "joy_adult": 5,
    "anger_adult": 1,
    "love_adult": 4,
    "fear_adult": 3,
    "excitement_adult": 5,
    "loneliness_adult": 1,
    "shame_adult": 1,
    "satisfaction_adult": 4,
    "sadness_adult": 2,
    "frustration_adult": 2,
    "pleasure_adult": 4,
    "jealousy_adult": 1,
    "anxiety_adult": 4,
    "inspiration_adult": 2,
    "regret_adult": 1,
    "boredom_adult": 1,
    "relief_adult": 2
  },
  "31": {
    "name": "Ibrahima",
    "age": 30,
    "joy_child": 4,
    "anger_child": 2,
    "love_child": 4,
    "fear_child": 3,
    "excitement_child": 3,
    "loneliness_child": 1,
    "shame_child": 2,
    "satisfaction_child": 4,
    "sadness_child": 2,
    "frustration_child": 3,
    "pleasure_child": 4,
    "jealousy_child": 2,
    "anxiety_child": 2,
    "inspiration_child": 4,
    "regret_child": 1,
    "boredom_child": 2,
    "relief_child": 4,
    "joy_teen": 3,
    "anger_teen": 2,
    "love_teen": 3,
    "fear_teen": 2,
    "excitement_teen": 2,
    "loneliness_teen": 3,
    "shame_teen": 2,
    "satisfaction_teen": 3,
    "sadness_teen": 2,
    "frustration_teen": 3,
    "pleasure_teen": 3,
    "jealousy_teen": 2,
    "anxiety_teen": 4,
    "inspiration_teen": 1,
    "regret_teen": 2,
    "boredom_teen": 2,
    "relief_teen": 3,
    "joy_ya": 3,
    "anger_ya": 3,
    "love_ya": 4,
    "fear_ya": 3,
    "excitement_ya": 2,
    "loneliness_ya": 3,
    "shame_ya": 4,
    "satisfaction_ya": 2,
    "sadness_ya": 3,
    "frustration_ya": 4,
    "pleasure_ya": 2,
    "jealousy_ya": 2,
    "anxiety_ya": 3,
    "inspiration_ya": 2,
    "regret_ya": 4,
    "boredom_ya": 3,
    "relief_ya": 3,
    "joy_adult": 4,
    "anger_adult": 1,
    "love_adult": 5,
    "fear_adult": 2,
    "excitement_adult": 4,
    "loneliness_adult": 1,
    "shame_adult": 3,
    "satisfaction_adult": 3,
    "sadness_adult": 2,
    "frustration_adult": 3,
    "pleasure_adult": 4,
    "jealousy_adult": 2,
    "anxiety_adult": 3,
    "inspiration_adult": 4,
    "regret_adult": 1,
    "boredom_adult": 2,
    "relief_adult": 3
  },
  "32": {
    "name": "Néo",
    "age": 19,
    "joy_child": 4,
    "anger_child": 3,
    "love_child": 2,
    "fear_child": 2,
    "excitement_child": 4,
    "loneliness_child": 1,
    "shame_child": 1,
    "satisfaction_child": 3,
    "sadness_child": 3,
    "frustration_child": 2,
    "pleasure_child": 4,
    "jealousy_child": 2,
    "anxiety_child": 1,
    "inspiration_child": 2,
    "regret_child": 1,
    "boredom_child": 2,
    "relief_child": 2,
    "joy_teen": 4,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 4,
    "loneliness_teen": 1,
    "shame_teen": 1,
    "satisfaction_teen": 4,
    "sadness_teen": 2,
    "frustration_teen": 2,
    "pleasure_teen": 3,
    "jealousy_teen": 3,
    "anxiety_teen": 2,
    "inspiration_teen": 3,
    "regret_teen": 3,
    "boredom_teen": 2,
    "relief_teen": 3,
    "joy_ya": 4,
    "anger_ya": 2,
    "love_ya": 4,
    "fear_ya": 1,
    "excitement_ya": 4,
    "loneliness_ya": 1,
    "shame_ya": 2,
    "satisfaction_ya": 4,
    "sadness_ya": 3,
    "frustration_ya": 3,
    "pleasure_ya": 4,
    "jealousy_ya": 3,
    "anxiety_ya": 2,
    "inspiration_ya": 5,
    "regret_ya": 2,
    "boredom_ya": 2,
    "relief_ya": 4,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  },
  "33": {
    "name": "Adel",
    "age": 20,
    "joy_child": 5,
    "anger_child": 2,
    "love_child": 1,
    "fear_child": 3,
    "excitement_child": 4,
    "loneliness_child": 1,
    "shame_child": 4,
    "satisfaction_child": 5,
    "sadness_child": 2,
    "frustration_child": 3,
    "pleasure_child": 5,
    "jealousy_child": 2,
    "anxiety_child": 2,
    "inspiration_child": 5,
    "regret_child": 1,
    "boredom_child": 3,
    "relief_child": 4,
    "joy_teen": 3,
    "anger_teen": 3,
    "love_teen": 3,
    "fear_teen": 3,
    "excitement_teen": 4,
    "loneliness_teen": 2,
    "shame_teen": 3,
    "satisfaction_teen": 2,
    "sadness_teen": 3,
    "frustration_teen": 2,
    "pleasure_teen": 4,
    "jealousy_teen": 1,
    "anxiety_teen": 1,
    "inspiration_teen": 2,
    "regret_teen": 1,
    "boredom_teen": 1,
    "relief_teen": 2,
    "joy_ya": 4,
    "anger_ya": 4,
    "love_ya": 4,
    "fear_ya": 3,
    "excitement_ya": 5,
    "loneliness_ya": 3,
    "shame_ya": 1,
    "satisfaction_ya": 4,
    "sadness_ya": 4,
    "frustration_ya": 3,
    "pleasure_ya": 5,
    "jealousy_ya": 2,
    "anxiety_ya": 2,
    "inspiration_ya": 5,
    "regret_ya": 3,
    "boredom_ya": 2,
    "relief_ya": 2,
    "joy_adult": null,
    "anger_adult": null,
    "love_adult": null,
    "fear_adult": null,
    "excitement_adult": null,
    "loneliness_adult": null,
    "shame_adult": null,
    "satisfaction_adult": null,
    "sadness_adult": null,
    "frustration_adult": null,
    "pleasure_adult": null,
    "jealousy_adult": null,
    "anxiety_adult": null,
    "inspiration_adult": null,
    "regret_adult": null,
    "boredom_adult": null,
    "relief_adult": null
  }
}
